import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';

const AboutContentDiv = styled.div`
  h3 {
    margin-bottom: 75px;

    ${screen.below(bp.mobile, `
      margin-bottom: 22px;
    `)};
  }

  & > span {
    text-align: left;
  }
`;

export default AboutContentDiv;
